import { MainApi } from "./MainApi";
import { SignPostDTO } from "../types/signup";

export class SignupApi {
  static baseUrl = `${MainApi.dcasUrlPrefix}/auth/user`;

  static signupMember = (condition: SignPostDTO) => () => MainApi.api.post(`${SignupApi.baseUrl}/signup`, condition);
}
